import {createContext} from "use-context-selector";
import React from "react";
import {useAppContextState} from "app/@hooks";


const Context = createContext({})
const initialState = {
    calendarData: {}, sliderColor: [-10,3],
    showModalDay: false, infoDay: {}, isLoading: true,
    priceByNight: false, dates: [], monthYear: null
}

export function AppCalendarProvider({children}) {

    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context